import { IUnitServiceHistoryInputDto, UnitServiceHistoryClient } from 'api/api';
import { AsyncOperationBuilder } from 'utilities/api-helper';
import { unitServiceHistoryClient } from '../api-clients';
import { createUnitServiceHistoryAction, getLatestUnitServiceHistoriesAction, getUnitServiceHistoriesAction } from './actions';

export function getUnitServiceHistories(unitId: number, startDate?: Date, endDate?: Date) {
	return AsyncOperationBuilder(
		getUnitServiceHistoriesAction,
		apiClient => (apiClient as UnitServiceHistoryClient).getAllUnitServiceHistory(unitId, startDate, endDate),
		undefined,
		unitServiceHistoryClient
	);
}

export function getLatestServiceDocumentTypes(unitId: number) {
	return AsyncOperationBuilder(
		getLatestUnitServiceHistoriesAction,
		apiClient => (apiClient as UnitServiceHistoryClient).getLatestDocumentTypesByUnitId(unitId),
		{ unitId },
		unitServiceHistoryClient
	);
}

export function createUnitServiceHistory(unitServiceHistory: IUnitServiceHistoryInputDto) {
	return AsyncOperationBuilder(
		createUnitServiceHistoryAction,
		apiClient => (apiClient as UnitServiceHistoryClient).uploadServiceDocument(unitServiceHistory.unitId, unitServiceHistory.file, unitServiceHistory.dateOfService, unitServiceHistory.serviceDocumentType, unitServiceHistory.comment),
		unitServiceHistory,
		unitServiceHistoryClient
	);
}
